import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-maintenance-screen',
    templateUrl: './maintenance-screen.component.html',
    styleUrls: ['./maintenance-screen.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MaintenanceScreenComponent {}
